export default "__VITE_ASSET__DGDVWljl__"